import type { DatabaseShardDirectoryCompleteSource } from '@blocksuite/affine/blocks/database';

/** The reads of a database data source the readiness check needs. */
export type DatabaseSnapshotReadinessSource = Pick<
  DatabaseShardDirectoryCompleteSource,
  'getCompleteShardDirectory'
> & {
  getLogicalRowIdsSnapshot: () => string[];
};

/**
 * Whether the local snapshot holds every row of the database. While directory
 * parts of the database are still loading, it is not loaded yet.
 */
export function isDatabaseSnapshotFullyLoaded(
  dataSource: DatabaseSnapshotReadinessSource
): boolean {
  const directory = dataSource.getCompleteShardDirectory();
  // A missing part never loads; the bounded waits of the callers end on it.
  if (directory.status !== 'ready') return false;

  const expectedRows = directory.manifest.shards.reduce(
    (sum, shard) => sum + shard.rowCount,
    0
  );
  if (expectedRows === 0) return true;

  try {
    return dataSource.getLogicalRowIdsSnapshot().length >= expectedRows;
  } catch {
    return false;
  }
}
